import { useQuery } from "@tanstack/react-query";

import { api } from "../utils/api";
import { ApiResponse } from "../types/api";
import { ReleaseNote } from "../types/releaseNotes";

const LAST_SEEN_KEY = "lastSeenReleaseNoteId";

export const getLastSeenReleaseNoteId = (): number => {
    return parseInt(localStorage.getItem(LAST_SEEN_KEY) ?? "0", 10);
};

export const markReleaseNotesAsSeen = (latestId: number) => {
    localStorage.setItem(LAST_SEEN_KEY, String(latestId));
};

const RELEASE_NOTES_BASE_URL = import.meta.env.VITE_RELEASE_NOTES_API_URL;
const SHOW_UNRELEASED = import.meta.env.VITE_SHOW_UNRELEASED === "true";

const fetchReleaseNotes = async (): Promise<ReleaseNote[]> => {
    let notes: ReleaseNote[];
    if (RELEASE_NOTES_BASE_URL) {
        const response = await fetch(`${RELEASE_NOTES_BASE_URL}/api/release-notes`);
        if (!response.ok) throw new Error("Failed to fetch release notes");
        const json: ApiResponse<ReleaseNote[]> = await response.json();
        notes = json.data ?? [];
    } else {
        const response = await api.get<ApiResponse<ReleaseNote[]>>("/api/release-notes");
        notes = response.data ?? [];
    }
    return SHOW_UNRELEASED ? notes : notes.filter((n) => n.release_version !== null);
};

export const useReleaseNotes = () => {
    return useQuery<ReleaseNote[]>({
        queryKey: ["releaseNotes"],
        queryFn: fetchReleaseNotes,
        refetchInterval: 5 * 60 * 1000,
        refetchIntervalInBackground: false,
        staleTime: 5 * 60 * 1000,
    });
};
